import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { Services } from './Services.js';
import { servicesProviderPlatformDataSchema } from './ServicesProviderPlatformData.js';

class ServicesProviderPlatform extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderPlatformDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderPlatform.validation', `ServicesProviderPlatform data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.PLATFORM,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
registerServiceProvider(Services.PLATFORM, ServicesProviderPlatform);

export { ServicesProviderPlatform };
//# sourceMappingURL=ServicesProviderPlatform.js.map
